var _desc, _defs, _circle, _circle2, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfileWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14.069092,
    height: 16.999878,
    viewBox: "0 0 14.0691 16.9999",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "\n\t\t\tCreated with Pixso.\n\t")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    }
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 73",
    cx: 7,
    cy: 4,
    r: 3.5,
    fill: "#000000",
    fillOpacity: 0
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 73",
    cx: 7,
    cy: 4,
    r: 3.5,
    stroke: "#FFFFFF",
    strokeOpacity: 1,
    strokeWidth: 1,
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path 310",
    d: "M7.03 10.69C2.62 10.69 0.5 13.44 0.5 15.04L0.5 16.49L13.56 16.49L13.56 15.04C13.56 13.45 11.44 10.69 7.03 10.69Z",
    fill: "#000000",
    fillOpacity: 0,
    fillRule: "nonzero"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path 310",
    d: "M0.5 15.04L0.5 16.49L13.56 16.49L13.56 15.04C13.56 13.45 11.44 10.69 7.03 10.69C2.62 10.69 0.5 13.44 0.5 15.04Z",
    stroke: "#FFFFFF",
    strokeOpacity: 1,
    strokeWidth: 1,
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileWhite);
export default __webpack_public_path__ + "static/media/profile_white.bb1b84dcbcb10c096fb66e5aea468648.svg";
export { ForwardRef as ReactComponent };